let backdropInactivatingTimeout = null

export const backdropState = {
    defaultState: {
        backdropActive: false,
        backdropBlocking: true,
        backdropInactivating: false,
        backdropActiveElement: null,
        backdropActiveItem: null,
    },
    actions: {
        activateBackdrop: (payload, state) => {
            if (backdropInactivatingTimeout) {
                clearTimeout(backdropInactivatingTimeout)
                backdropInactivatingTimeout = null
            }
            return {
                ...state,
                backdropActive: true,
                backdropInactivating: false,
                backdropActiveElement: payload?.element || null,
                backdropActiveItem: payload?.item || null,
                backdropBlocking: payload?.blocking !== undefined ? payload.blocking : true,
            }
        },
        deactivateBackdrop: (_, state, setSharedState) => {
            if (backdropInactivatingTimeout) {
                clearTimeout(backdropInactivatingTimeout)
            }
            backdropInactivatingTimeout = setTimeout(() => {
                setSharedState(state => ({
                    ...state,
                    backdropInactivating: false,
                    backdropActiveElement: null,
                    backdropActiveItem: null,
                }))
                backdropInactivatingTimeout = null
            }, 300)
            return {...state, backdropActive: false, backdropInactivating: true}
        },
        finishBackdropDeactivation: (_, state) => {
            backdropInactivatingTimeout = null
            return {...state, backdropInactivating: false}
        },
    },
}
